import type { mainStore } from "@/mainStore";
import { throwIfNonSuccessStatus, fetchAuth } from "@/lib/fetchHelpers.3";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default async function getData<T = any>(context: mainStore, extraDataKey: string | null, urlFunc: () => Promise<string>, checkData?: (data: T) => Promise<boolean> | boolean) {
    let data: T | null = null;
    if (extraDataKey != null) {
        try {
            const extraDataElement = document.getElementById("extraData");
            if (extraDataElement != null) {
                extraDataElement.remove();
                if (extraDataElement.dataset["extradataKey"] == extraDataKey) {
                    const extraDataString = extraDataElement.innerHTML;
                    data = JSON.parse(extraDataString) as T;
                }
            }
        } catch {
            // ignore
        }
    }
    if (data == null || (checkData != null && !(await checkData(data)))) {
        const dataUrl = await urlFunc();
        const dataResponse = await fetchAuth(context, dataUrl);
        throwIfNonSuccessStatus(dataResponse);
        data = (await dataResponse.json()) as T;
    }
    return data;
}
